<template>
  <div v-if="filters.length" class="d-inline-flex flex-wrap">
    <div class="input-wrapper" v-for="field in filters" :key="field.key">
      <template v-if="field.key === 'document_type'">
        <input-widget :model="searchModel"
                      :label="false"
                      :options="{placeholder: getIdentificationFieldFilterLabel(field)}"
                      attribute="document_type"
                      value-field="value"
                      display-field="${item.key}"
                      type="select2"
                      :items="customerIdentificationTypes"/>
      </template>
      <template v-else-if="field.key === 'citizenship_code' || field.key === 'country_of_birth_code' || field.key === 'residency_code'">
        <country-select-input-widget :model="searchModel"
                                     :attribute="field.key"
                                     :label="false"
                                     :options="{placeholder: getIdentificationFieldFilterLabel(field)}"/>
      </template>
      <template v-else-if="field.type === 'daterange'">
        <b-form-group class="">
          <date-range-picker
            class="d-flex w-100"
            showWeekNumbers
            showDropdowns
            ref="picker"
            :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
            v-model="searchModel[field.key]">
            <template v-slot:input="picker" style="min-width: 350px;">
                        <span v-if="!picker.startDate" class="text-muted">
                          {{ getIdentificationFieldFilterLabel(field) }}
                        </span>
              <span style="font-size: 10px" v-else>
                          {{ picker.startDate | toDate }} - {{ picker.endDate | toDate }}
                        </span>
            </template>
          </date-range-picker>
        </b-form-group>
      </template>
      <input-widget v-else :label="getIdentificationFieldFilterLabel(field)" :placeholder="field.label"
                    :model="searchModel"
                    :attribute="field.key" :type="field.type"/>
    </div>
  </div>
</template>

<script>
import InputWidget from "../../core/components/input-widget/InputWidget.vue";
import CountrySelectInputWidget from "../../core/widgets/CountrySelectInputWidget.vue";
import DateRangePicker from 'vue2-daterange-picker'
import {createNamespacedHelpers} from "vuex";
import BaseModel from "../../core/components/input-widget/BaseModel";


const {mapState: globalMapState} = createNamespacedHelpers('global');

export default {
  name: 'CustomerIdentificationFilters',
  components: {
    InputWidget,
    CountrySelectInputWidget,
    DateRangePicker
  },
  data() {
    return {
      dateRange: {startDate: null, endDate: null}
    }
  },
  props: {
    searchModel: BaseModel,
    filters: Array
  },
  computed: {
    ...globalMapState({
      customerIdentificationTypes: state => state.customerIdentificationTypes,
      identificationFieldsFilters: state => state.identificationFieldsFilters
    }),
  },
  methods: {
    getIdentificationFieldFilterLabel(field) {
      if (field.type === 'text') {
        return false
      }
      return field.label;
    }
  }
}
</script>


<style scoped lang="scss">

</style>
